import isString from './isString.js';

/**
 * Make Base64 encoded string url-safe
 * @param {string} encodedString
 * @returns {string}
 */
const toUrl = (encodedString) => {
	return encodedString.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

/**
 * Create Base64 string from provided value
 * @param {string} decodedString
 * @returns {string}
 */
const encode = (decodedString) => {
	if (!isString(decodedString)) {
		return '';
	}
	return btoa(decodedString);
};

/**
 * Create url-safe Base64 string from provided value
 * @param {string} decodedString
 * @returns {string}
 */
const urlEncode = (decodedString) => {
	if (!isString(decodedString)) {
		return '';
	}
	const encodedString = encode(decodedString);
	return toUrl(encodedString);
};

/**
 * Decode Base64 string
 * @param {string} encodedString
 * @returns {string}
 */
const decode = (encodedString) => {
	if (!isString(encodedString)) {
		return '';
	}
	return atob(encodedString);
};

/**
 * Decode url-safe Base64 string
 * @param {string} encodedString
 * @param {boolean} [doNotDecode=false] If true, raw Base64 will be returned
 * @returns {string}
 */
const urlDecode = (encodedString, doNotDecode = false) => {
	if (!isString(encodedString)) {
		return '';
	}
	let sourceString = encodedString;
	while (sourceString.length % 4 > 0) {
		sourceString += '=';
	}
	const sanitizedString = sourceString.replace(/-/g, '+').replace(/_/g, '/');
	return doNotDecode ? sanitizedString : decode(sanitizedString);
};

export default {
	encode,
	urlEncode,
	decode,
	urlDecode,
	toUrl
};
